import styled from 'styled-components'

const Heading = styled.h3<{ $borderColor: string }>`
  align-items: center;
  ${(props) => props.$borderColor !== '' && `border-left: 5px solid ${props.$borderColor}`};
  display: flex;
  height: 23px;
  padding-left: 11px;
`

export default Heading
